import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export const patternFormValidator = (pattern: string | RegExp, example: string): ValidatorFn => {
  const validatorPatternFn = Validators.pattern(pattern);
  return (control: AbstractControl) => {
    const error = validatorPatternFn(control);
    if (error) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      error.pattern.example = example;
    }
    return error;
  };
};
